import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a57ac5720dc4674c723e05502a9e27cdeb from "./generated-f1c35ec2-dadd-4b07-8344-14ff0c8d98a5.json";

import a2c62b37589cba9ea9bbc9c85086321bfb from "./generated-a3ed6a48-6038-4f5f-9c01-ce2a53207f19.json";

import a51f3083ede7bd50581e03230c3005eb4b from "./generated-6160e8f6-e655-4d1c-957c-b5d4c655593b.json";

import a35ddaf4627226850eb62d8fc2fb7f26cb from "./generated-a6247843-9ce7-4a88-9d0b-196d0e600ec8.json";

import a314d1269e9b2aac5c3387efb63899309b from "./generated-2977ff01-70f1-4d28-87f2-ef49ac1c7f5a.json";

import a4f822a85045df10173e2482503cb2c30b from "./generated-d852ab38-5f54-490f-ba98-8c1dad7977d3.json";

import a622e82dfba791327956ae747f091314bb from "./generated-499193ef-b32c-42aa-ac09-5d8367203a65.json";

import a8c4d7f3a5e7aaa8b9452b7345a633971b from "./generated-dcb43171-203b-41bd-a7b0-9de9fc2d95fb.json";

import a6c923279f9c64156c96e66036db5b793b from "./generated-1816c075-d167-4325-91d3-5a339f820caa.json";

import acc9d78420a5d07c0e181ebf01d38649eb from "./generated-1717ca67-ff28-4920-ba12-0db356e18dc0.json";

import a7b6ff93d360eabcc23f79adeb3027fedb from "./generated-14a5e77f-ac55-4ddc-b91a-57d5294e8ee5.json";

import a4db367fbffb050d0f85dfc26875c79e7b from "./generated-b0b68331-de9c-404a-b4d5-1f5c9875243f.json";

import ab939ac185a77f16e380bc23b9efac96bb from "./generated-48471ec1-3fa6-4410-b4af-7fcaa0e479cd.json";

import af0fb63ad627594bf693a733c1ed325b3b from "./generated-88ab325f-877e-46d8-acdc-a792eebf0368.json";

import a5c7c078ef7c7a7489680e20aa2f6eb8ab from "./generated-72c46629-b085-41d0-82e5-214ead73bf52.json";

import a9689e5536a30a4b0c2c7fd18f6557d94b from "./generated-a3b0981a-3c99-4969-a4d3-2cca00901bd8.json";

import a0f73fad4d737d21d957724231f45c3edb from "./generated-417fe4bb-6d29-4c51-8266-946c9176aa59.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a57ac5720dc4674c723e05502a9e27cdeb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a2c62b37589cba9ea9bbc9c85086321bfb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a51f3083ede7bd50581e03230c3005eb4b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a35ddaf4627226850eb62d8fc2fb7f26cb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a314d1269e9b2aac5c3387efb63899309b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a4f822a85045df10173e2482503cb2c30b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a622e82dfba791327956ae747f091314bb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a8c4d7f3a5e7aaa8b9452b7345a633971b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a6c923279f9c64156c96e66036db5b793b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(acc9d78420a5d07c0e181ebf01d38649eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a7b6ff93d360eabcc23f79adeb3027fedb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a4db367fbffb050d0f85dfc26875c79e7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a6c923279f9c64156c96e66036db5b793b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ab939ac185a77f16e380bc23b9efac96bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(af0fb63ad627594bf693a733c1ed325b3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a6c923279f9c64156c96e66036db5b793b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a5c7c078ef7c7a7489680e20aa2f6eb8ab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a9689e5536a30a4b0c2c7fd18f6557d94b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0f73fad4d737d21d957724231f45c3edb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a5c7c078ef7c7a7489680e20aa2f6eb8ab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */